<!-- 404页面 -->
<template>
  <div class="no-path-vue">
    <span @click="pushHme" class="pushHome">404未找到页面，点击返回</span>
  </div>
</template>

<script>
export default {
  name: 'notFound',
  data () {
    return {
    }
  },
  components: {},
  computed: {},
  mounted () { },
  methods: {
    pushHme () {
      this.$router.back()
    }
  }
}
</script>
